import { OwnerInformation } from '@/legacy/components/user/onboardingWizard/company/ownershipInformation/model/OwnerInformation';
import AuthFetchService from '@/legacy/services/authFetch';
import * as companyService from '@/legacy/services/company';
import { ErrorModel } from '@/legacy/utils/reactHelpers';

class OwnershipInformationService {
  public static async get(): Promise<Array<OwnerInformation>> {
    const companyId: string = companyService.Instance.CompanyId();
    const url = `${import.meta.env.FEATURE_VERIFICATION_BASE_URL}/company/${companyId}/owners`;
    const response = await AuthFetchService.httpGet(url);

    if (response.ok) {
      return response.json();
    }

    throw new Error(response.statusText);
  }

  public static async update(
    owners: Array<OwnerInformation>
  ): Promise<Array<OwnerInformation> | ErrorModel> {
    const companyId: string = companyService.Instance.CompanyId();
    const url = `${import.meta.env.FEATURE_VERIFICATION_BASE_URL}/company/${companyId}/owners`;
    const response = await AuthFetchService.httpPut(url, JSON.stringify(owners));

    if (response.ok) {
      return response.json();
    }

    if (response.status === 400) {
      return Promise.reject(await response.json());
    }

    throw new Error(response.statusText);
  }
}

export default OwnershipInformationService;
